<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
            <el-breadcrumb-item
                :to="{
                    path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management',
                }"
                >个人赛赛务工具</el-breadcrumb-item
            >
            <el-breadcrumb-item>考场管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <el-tabs v-model="activeName" type="card" @tab-click="tabHandleClick">
            <el-tab-pane label="考场管理" name="first">
                <!-- 考场筛选 -->
                <el-card>
                    <el-row class="title_row">
                        <el-col>
                            <span class="title_class">考场筛选</span>
                        </el-col>
                    </el-row>
                    <el-form
                        :model="queryForm"
                        class="filter_Form"
                        label-width="90px"
                        ref="queryFormRef"
                    >
                        <el-row :gutter="50">
                            <el-col :span="6">
                                <el-form-item label="考场名称" prop="name">
                                    <el-input
                                        v-model="queryForm.name"
                                        placeholder="请输入"
                                        type="text"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否已满" prop="fullState">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.fullState"
                                        clearable
                                    >
                                        <el-option
                                            v-for="item in dict_fullState"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="考场类型" prop="type">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.type"
                                        clearable
                                    >
                                        <el-option
                                            v-for="item in dictExamType"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否启用" prop="state">
                                    <el-select
                                        v-model="queryForm.state"
                                        placeholder="请选择"
                                        style="width: 100%"
                                        clearable
                                    >
                                        <el-option
                                            v-for="item in dictExamstatus"
                                            :key="item.dictCode"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="场次" prop="ampm">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.ampm"
                                        clearable
                                    >
                                        <el-option
                                            v-for="(item, index) in time_form"
                                            :key="index"
                                            :label="item"
                                            :value="item"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row :gutter="20" type="flex" justify="end">
                        <el-col :span="2">
                            <el-button
                                type="primary"
                                style="width: 100%"
                                @click="handleToSearch"
                                >查询</el-button
                            >
                        </el-col>
                        <el-col :span="2">
                            <el-button
                                type="primary"
                                plain
                                style="width: 100%"
                                @click="handleToReset"
                                >重置</el-button
                            >
                        </el-col>
                    </el-row>
                </el-card>
                <!-- 考场列表 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col :span="12">
                            <span class="title_class">考场列表</span>
                        </el-col>
                        <el-col :span="12">
                            <div class="div_algin_right">
                              <el-button type="primary" plain icon="el-icon-refresh-right" @click="showResetDialog">重置考生</el-button>
                              <el-button type="primary" @click="handleToCreate">新建考场</el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <el-table
                        header-cell-class-name="tableHeaderStyle"
                        :data="dataList"
                        border
                        stripe
                    >
                        <el-table-column
                            label="序号"
                            type="index"
                            width="50px"
                        ></el-table-column>
                        <el-table-column
                            label="考场名称"
                            prop="name"
                            width="140px"
                        >
                            <template slot-scope="{ row }">
                                <span type="primary">{{
                                    row.name || "-"
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="考场类型"
                            prop="roomType"
                            width="90"
                        >
                            <template slot-scope="{ row }">
                                <el-tag
                                    :type="row.roomType === 1 ? '' : 'success'"
                                    size="mini"
                                    >{{
                                        row.roomType === 1
                                            ? "线上考场"
                                            : "线下考场"
                                    }}</el-tag
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="详细地址" prop="address">
                            <template slot-scope="{ row }">
                                {{ row.address }}
                            </template>
                        </el-table-column>
                        <el-table-column label="场次" prop="ampm">
                        </el-table-column>
                        <el-table-column
                            label="开始时间"
                            prop="startTime"
                            width="94px"
                        >
                            <template slot-scope="{ row }">
                                {{ row.startTime || "-" }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="结束时间"
                            prop="endTime"
                            width="94px"
                        >
                            <template slot-scope="{ row }">
                                {{ row.endTime || "-" }}
                            </template>
                        </el-table-column>
                        <el-table-column label="考位数量" prop="sitnum">
                            <template slot-scope="{ row }">
                                <span
                                    style="
                                        color: red;
                                        font-size: 20px;
                                        font-weight: bold;
                                    "
                                    >{{ row.sitnum || "-" }}</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="已选数量" prop="cursit">
                            <template slot-scope="{ row }">
                                <span
                                    style="
                                        color: green;
                                        font-size: 20px;
                                        font-weight: bold;
                                    "
                                    >{{ row.cursit || "-" }}</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="是否已满" prop="fullState">
                            <template slot-scope="{ row }">
                                <el-tag
                                    :type="row.fullState ? 'danger' : 'success'"
                                >
                                    {{ row.fullState ? "是" : "否" }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="注意事项"
                            prop="roomstr"
                            width="120px"
                            :show-overflow-tooltip="true"
                        >
                            <template slot-scope="{ row }">
                                <span>{{
                                    row.roomstr ? row.roomstr : "无"
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="是否启用"
                            prop="state"
                            fixed="right"
                        >
                            <template slot-scope="{ row }">
                                <el-switch
                                    :active-value="true"
                                    :inactive-value="false"
                                    v-model="row.state"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    @change="stateChange(row)"
                                >
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            fixed="right"
                            width="160px"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    icon="el-icon-edit"
                                    size="small"
                                    style="margin-right: 12px"
                                    @click="showEditDialog(scope.row)"
                                    >修改</el-button
                                >

                                <el-button
                                    type="text"
                                    size="small"
                                    style="margin-right: 12px"
                                    @click="handleToDetails(scope.row)"
                                    >选手管理</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageInfo.pageNum"
                        :page-sizes="[10, 20, 40, 80]"
                        :page-size="pageInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    >
                    </el-pagination>
                </el-card>
            </el-tab-pane>
        </el-tabs>
        <!-- 新增、修改考场 -->
        <el-dialog
            :title="`${editType === 0 ? '新建' : '修改'}考场`"
            :visible.sync="dialogVisible"
            width="70%"
            @close="handleCloseDialog"
        >
            <el-form
                :model="dataForm"
                label-width="80px"
                ref="dataFormRef"
                :rules="dataFormRules"
            >
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="考场名称" prop="name">
                            <el-input
                                v-model="dataForm.name"
                                placeholder="请输入"
                                type="text"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="考场地址" prop="address">
                            <el-input
                                v-model="dataForm.address"
                                placeholder="请输入"
                                type="text"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="考场类型" prop="type">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="dataForm.type"
                            >
                                <el-option
                                    v-for="item in dictExamType"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="考位数量" prop="sitnum">
                            <el-input
                                v-model="dataForm.sitnum"
                                placeholder="请输入"
                                type="number"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="已占数量" prop="cursit">
                            <el-input
                                v-model="dataForm.cursit"
                                placeholder="请输入"
                                type="number"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否已满" prop="fullState">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="dataForm.fullState"
                            >
                                <el-option
                                    v-for="item in dict_fullState"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="场次" prop="ampm">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="dataForm.ampm"
                            >
                                <el-option
                                    v-for="(item, index) in time_form"
                                    :key="index"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否启用" prop="state">
                            <el-select
                                v-model="dataForm.state"
                                placeholder="请选择"
                                style="width: 100%"
                                clearable
                            >
                                <el-option
                                    v-for="item in dictExamstatus"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="比赛时间" prop="dateRange">
                            <el-date-picker
                                v-model="dataForm.dateRange"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="daterangeChange"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="注意事项" prop="roomstr">
                            <el-input
                                type="textarea"
                                placeholder="请输入"
                                v-model="dataForm.roomstr"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleToSubmit">{{
                    editType === 0 ? "新 建" : "保存修改"
                }}</el-button>
            </span>
        </el-dialog>
            <!-- 重置考生 -->
    <el-dialog title="重置考生"
      :visible.sync="resetVisible"
      width="30%"
      @close="resetCloseDialog">
      <el-form
        :model="resetPlayerForm"
        label-width="120px"
        ref="addPlayerRef"
        :rules="resetPlayerFormRules"
      >
      <el-form-item label="手机号" prop="phones">
          <el-input placeholder="请输入手机号" v-model="resetPlayerForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetPhone">重 置</el-button>
      </span>
    </el-dialog>
    </div>
</template>
<script>
import { nationalExamCreate, nationalQueryExaminationListPage, nationalExamEdit, setNationalExamStatue, removeExaminationRoomUseByPhone } from '@/http/api'
export default {
  data () {
    return {
      resetVisible: false,
      dataList: [],
      total: 0,
      pageInfo: {
        pageNum: 1,
        pageSize: 10
      },
      resetPlayerForm: {
        phone: ''
      },
      resetPlayerFormRules: {
        name: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        name: '',
        fullState: '',
        type: '',
        ampm: ''
      },
      dict_district: [],
      dict_group: this.$userInfo.dict_group(),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      // roomTypeList: this.$userInfo.match_type(),
      time_form: ['am', 'pm'],
      // 是否启用
      dictExamstatus: [
        {
          dictCode: 0,
          dictLabel: '未启用',
          dictValue: false
        },
        {
          dictCode: 1,
          dictLabel: '已启用',
          dictValue: true
        }
      ],
      dict_fullState: [
        {
          dictCode: 0,
          dictLabel: '已满',
          dictValue: true
        },
        {
          dictCode: 1,
          dictLabel: '未满',
          dictValue: false
        }
      ],
      dictExamType: [
        {
          dictCode: 0,
          dictLabel: '线上考场',
          dictValue: 'online'
        },
        {
          dictCode: 1,
          dictLabel: '线下考场',
          dictValue: 'offline'
        }
      ],
      dialogVisible: false,
      dataFormRules: {
        name: [{ required: true, message: '请输入考场名称', trigger: 'blur' }],
        sitnum: [{ required: true, message: '请输入考位数量', trigger: 'blur' }],
        cursit: [{ required: true, message: '请输入已占数量', trigger: 'blur' }],
        address: [{ required: true, message: '请输入考场地址', trigger: 'blur' }],
        roomstr: [{ required: true, message: '请输入注意事项', trigger: 'blur' }],
        ampm: [{ required: true, message: '请选择场次', trigger: 'change' }],
        roomType: [{ required: true, message: '请选择考场类型', trigger: 'change' }],
        dateRange: [{ required: true, message: '请选择比赛时间', trigger: 'change' }],
        state: { required: true, message: '请选择状态', trigger: 'change' },
        fullState: { required: true, message: '请选择是否满额', trigger: 'change' },
        type: [{ required: true, message: '请选择考试类型', trigger: 'change' }]
      },
      dataForm: {
        activityType: this.$chnEngStatusCode.activityType,
        fullState: null,
        districtName: '',
        id: '',
        address: '',
        endTime: '',
        roomLevel: null,
        type: '',
        state: null,
        name: '',
        roomNotice: '',
        sitnum: '',
        cursit: '',
        startTime: '',
        roomForm: '',
        ampm: '',
        roomstr: '',
        roomCertificate: '',
        roomType: ''
      },
      editType: 0, // 弹窗0新建1修改
      editId: 0,
      importVisible: false,
      importForm: {
        districtId: '',
        season: '',
        districtName: '',
        roomType: '',
        activityType: this.$chnEngStatusCode.activityType,
        file: null
      },
      uploadInfo: {
        uploadUrl: `${this.$http.defaults.baseURL}/examination/importTemplatesTheSemiFinals`,
        headerObj: {
          Authorization: window.sessionStorage.getItem('token')
        }
      },
      activeName: 'first',
      queryDistrictTimeForm: {
        raceSchedule: '2',
        districtTimeId: '',
        season: this.$chnEngStatusCode.defaultSeason,
        districtType: 0,
        schoolId: '',
        districtTimeName: '',
        pageNum: 1,
        pageSize: 10
      },
      divisionList: [],
      time_total: 0,
      timeDialogVisible: false,
      editDistrictTimeForm: {
        chooseRoomStartEndTime: null,
        choosestartTime: '',
        chooseendTime: ''
      },
      editDistrictTimeFormRules: {
        chooseRoomStartEndTime: [{ required: true, message: '请选择选考场起止时间', trigger: 'change' }]
      },
      setInfo: {
        address: '',
        roomForm: '',
        roomTime: '',
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        activityType: this.$chnEngStatusCode.activityType
      },
      districtName: '',
      setInfoFormRules: {
        roomForm: [{ required: true, message: '请输入复赛形式', trigger: 'blur' }],
        // address: [{ required: true, message: '请输入考场地址', trigger: 'blur' }],
        roomTime: [{ required: true, message: '请选择考试开始日期', trigger: 'blur' }]
      }

    }
  },
  created () {
    this.dict_matchType = this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(value => { this.dict_matchType = value })
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    levelFormat (row) {
      return row.roomLevel ? this.dict_group.find(item => Number(item.dictValue) === row.roomLevel).dictLabel : '-'
    },
    handleToSearch () {
      this.pageInfo.pageNum = 1
      this.getList()
    },
    handleToReset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    async getList () {
      const params = { ...this.queryForm, ...this.pageInfo }
      nationalQueryExaminationListPage(params).then(res => {
        this.dataList = res.data.list
        this.total = res.data.total
      })
    },
    showResetDialog () {
      this.resetVisible = true
    },
    handleToCreate () {
      this.editType = 0
      this.dialogVisible = true
      this.dataForm.roomType = this.queryForm.roomType
    },
    handleCloseDialog () {
      this.dataForm = {
        activityType: this.$chnEngStatusCode.activityType,
        districtId: '',
        districtName: '',
        id: '',
        address: '',
        endTime: '',
        roomLevel: '',
        name: '',
        roomNotice: '',
        sitnum: '',
        roomstr: '',
        cursit: '',
        startTime: '',
        season: '',
        fullState: null,
        roomForm: '',
        ampm: '',
        roomCertificate: '',
        roomType: '',
        state: null,
        type: ''
      }
      if (this.hideUploadAdd) this.hideUploadAdd = false
      this.$refs.dataFormRef.resetFields()
      this.dialogVisible = false
    },
    handleSizeChange (e) {
      this.pageInfo.pageSize = e
      this.getList()
    },
    handleCurrentChange (e) {
      this.pageInfo.pageNum = e
      this.getList()
    },
    async showEditDialog (row) {
      Object.keys(this.dataForm).forEach(key => {
        if (key === 'roomLevel') {
          this.dataForm[key] = String(row[key])
        } else {
          this.dataForm[key] = row[key]
        }
      })

      // 比赛时间处理
      const dateRange = []
      dateRange[0] = new Date(row.startTime)
      dateRange[1] = new Date(row.endTime)
      this.$set(this.dataForm, 'dateRange', dateRange)

      this.editId = row.id
      this.editType = 1
      this.dialogVisible = true
    },
    handleToSubmit () {
      this.$refs.dataFormRef.validate(async valid => {
        if (!valid) return false
        if (this.editType === 0) delete this.dataForm.id
        delete this.dataForm.dateRange
        Object.keys(this.dataForm).forEach(key => {
          if (key === 'sitnum') {
            this.dataForm[key] = Number(this.dataForm[key])
          }
          if (key === 'startTime' || key === 'endTime') {
            this.dataForm[key] = this.$moment(this.dataForm[key]).format('YYYY-MM-DD HH:mm:ss')
          }
        })
        console.log(this.dataForm)
        if (this.editType === 0) {
          nationalExamCreate(this.dataForm).then(res => {
            this.$message.success('保存成功')
            this.handleCloseDialog()
            this.getList()
          })
        } else if (this.editType === 1) {
          nationalExamEdit(this.dataForm).then(res => {
            this.$message.success('修改成功')
            this.handleCloseDialog()
            this.getList()
          })
        }
      })
    },
    handleToDetails (row) {
      this.$router.push({
        path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_national_room_detail',
        query: {
          id: row.id
        }
      })
    },
    handleToReferee (row) {
      this.$router.push({
        path: '/academic_Management/rm',
        query: {
          id: row.id,
          r: '2', // 赛程-复赛
          d: row.districtId, // 赛区
          s: row.season, // 赛季
          flag: '3',
          group: '3'
        }
      })
    },
    daterangeChange (e) {
      if (e.length === 2) {
        this.dataForm.startTime = e[0]
        this.dataForm.endTime = e[1]
      }
    },
    distChange (e) {
      this.dataForm.districtName = this.dict_district.find(item => item.id === e).districtName
    },
    async stateChange (row) {
      const { id, state } = row
      setNationalExamStatue({ id, state }).then(res => {
        this.getList()
      })
    },
    tabHandleClick () {
      this.getList()
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryDistrictTimeFormRef.resetFields()
    },
    // 重置选手选考场信息
    resetPhone () {
      this.$confirm('是否重置该学生考场信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        removeExaminationRoomUseByPhone(this.resetPlayerForm).then(res => {
          this.resetVisible = false
          this.$message.success('重置成功')
        })
      }).catch(() => {
      })
    },
    // 比赛类型转文字
    matchTypeFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_matchType) {
        if (Object.hasOwnProperty.call(this.dict_matchType, key)) {
          const element = this.dict_matchType[key]
          if (element.id === data.raceSchedule + '') {
            temp = element.scheduleName
          }
        }
      }
      return temp
    }
  }
}
</script>
<style lang="less" scoped>
.mr-10 {
    margin-right: 10px;
}
.div_algin_right {
    text-align: right;
}
::v-deep .el-tabs--card > .el-tabs__header {
    background: #fff;
    margin-bottom: 0;
    border-bottom: none;
    border-top-left-radius: 4px;
}
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    // background-color: #fff !important;
    color: #606266 !important;
}
</style>
